export default {
  head_scripts: {
    title: 'Scripts de cabecera',
  },
  body_noscripts: {
    title: 'Noscripts de cuerpo',
    description: 'Inyectar código justo después de abrir el body',
  },
  google_site_verification: {
    title: 'Verificación de sitio de Google',
    label: 'Código de verificación de sitio de Google',
  },
  buttons: {
    save: 'Guardar',
  },
};
